import React from "react";
import { Link } from "react-router-dom";
import { formatBRL } from "@/lib/format";
import { getProductImageUrl } from "@/lib/utils";
import { ArrowRight } from "lucide-react";

export default function ProductCard({ product }) {
  return (
    <Link
      to={`/produto/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="card-soft p-5 flex flex-col gap-4 group"
    >
      <div className="aspect-square bg-gp-gradient-light overflow-hidden rounded-2xl relative">
        <img
          src={getProductImageUrl(product.image_url)}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3 bg-white/95 backdrop-blur px-3 py-1 rounded-full text-[10px] font-quicksand font-bold uppercase tracking-wider text-[#1BB0CE]">
          {product.category}
        </div>
        {product.stock <= 0 && (
          <div className="absolute top-3 right-3 bg-red-500/95 backdrop-blur px-3 py-1 rounded-full text-[10px] font-quicksand font-bold uppercase tracking-wider text-white font-semibold">
            Esgotado
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2 flex-1 px-1">
        <h3 className="font-quicksand font-bold text-base leading-tight text-[#3d3d3d]">
          {product.name}
        </h3>
        <p className="text-xs text-[#666] line-clamp-2 leading-relaxed">{product.description}</p>
      </div>
      <div className="flex items-end justify-between px-1 pt-3 border-t border-[#f1f1f3]">
        <div>
          <div className="font-quicksand text-xl font-extrabold text-[#1BB0CE]">{formatBRL(product.price)}</div>
        </div>
        <div className="w-9 h-9 rounded-full bg-gp-gradient flex items-center justify-center group-hover:scale-110 transition-transform shadow-md">
          <ArrowRight className="w-4 h-4 text-white" strokeWidth={2.5} />
        </div>
      </div>
    </Link>
  );
}
